import { render, staticRenderFns } from "./ChangeCredentials.vue?vue&type=template&id=45260cd0&scoped=true"
import script from "./ChangeCredentials.vue?vue&type=script&lang=js"
export * from "./ChangeCredentials.vue?vue&type=script&lang=js"
import style0 from "./ChangeCredentials.vue?vue&type=style&index=0&id=45260cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45260cd0",
  null
  
)

export default component.exports